import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-788bd692"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-background" }, null, -1));
const _hoisted_2 = {
    key: 0,
    class: "modalDialog-content modal-content"
};
const _hoisted_3 = { class: "message-header" };
const _hoisted_4 = { class: "modalDialog-contentArea message-body" };
const _hoisted_5 = {
    key: 0,
    class: "modalDialog-buttonArea modal-card-foot"
};
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalDialog',
    props: {
        active: { type: Boolean },
        title: {},
        severity: {},
        firstButtonText: {},
        firstButtonSeverity: {},
        secondButtonText: {},
        secondButtonSeverity: {},
        thirdButtonText: {},
        thirdButtonSeverity: {},
        loading: { type: Boolean },
        allowClose: { type: Boolean }
    },
    emits: ['close', 'firstbuttonselected', 'secondbuttonselected', 'thirdbuttonselected'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const onClose = () => {
            emit('close');
        };
        // If the combined length of the button text is long enough, we'll display them vertically instead of side-by-side
        const displayVertically = computed(() => {
            let len = 0;
            if (props.firstButtonText) {
                len += props.firstButtonText.length;
            }
            if (props.secondButtonText) {
                len += props.secondButtonText.length;
            }
            if (props.thirdButtonText) {
                len += props.thirdButtonText.length;
            }
            return len > 40;
        });
        return (_ctx, _cache) => {
            const _component_loading_spinner = _resolveComponent("loading-spinner");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["modal", { 'is-active': _ctx.active }])
            }, [
                _hoisted_1,
                (_ctx.active)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("article", {
                            class: _normalizeClass(["message", `is-${_ctx.severity}`])
                        }, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.title), 1),
                                (_ctx.allowClose)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "delete",
                                        "aria-label": "delete",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (onClose()))
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _renderSlot(_ctx.$slots, "default")
                            ]),
                            (_ctx.loading)
                                ? (_openBlock(), _createElementBlock("footer", _hoisted_5, [
                                    _createVNode(_component_loading_spinner, { size: "small" })
                                ]))
                                : (_openBlock(), _createElementBlock("footer", {
                                    key: 1,
                                    class: _normalizeClass(["modalDialog-buttonArea modal-card-foot", { 'modalDialog-buttonArea-vertical': displayVertically.value }])
                                }, [
                                    (_ctx.firstButtonText)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('firstbuttonselected'))),
                                            class: _normalizeClass(["button", `is-${_ctx.firstButtonSeverity}` + (displayVertically.value ? ' button-vertical' : '')])
                                        }, _toDisplayString(_ctx.firstButtonText), 3))
                                        : _createCommentVNode("", true),
                                    (_ctx.secondButtonText)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('secondbuttonselected'))),
                                            class: _normalizeClass(["button", `is-${_ctx.secondButtonSeverity}` + (displayVertically.value ? ' button-vertical' : '')])
                                        }, _toDisplayString(_ctx.secondButtonText), 3))
                                        : _createCommentVNode("", true),
                                    (_ctx.thirdButtonText)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 2,
                                            onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('thirdbuttonselected'))),
                                            class: _normalizeClass(["button", `is-${_ctx.thirdButtonSeverity}` + (displayVertically.value ? ' button-vertical' : '')])
                                        }, _toDisplayString(_ctx.thirdButtonText), 3))
                                        : _createCommentVNode("", true)
                                ], 2))
                        ], 2)
                    ]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
